import PropTypes from 'prop-types';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStopCircle } from '@fortawesome/free-regular-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTradePointInlineLabel } from 'src/helpers/tradeHelpers';
import { TRADE_RULE_STATE_CLOSED } from 'src/util/constants';

import TradeRuleTimelineStep from './TradeRuleTimelineStep';

/**
 * Description
 * @param {any} props
 * @returns {any} - TradeRuleTimelineStepClosed component
 */
function TradeRuleTimelineStepClosed(props) {
  const {
    metersMap, ruleId, tradeType, buyer, seller, timestamp, user, isCurrentStep,
    hasNextStep, timezone,
  } = props;

  const intl = useIntl();

  let description;

  if (buyer.tradePoint.id in metersMap) {
    description = (
      <FormattedMessage
        id="trade_rule.trade_rule_timeline.trade_rule_timeline_step_closed.buy.details"
        defaultMessage="{buyerTradepoint} no longer buying from {sellerTradepoint}"
        values={{
          buyerTradepoint: getTradePointInlineLabel(buyer.tradePoint, intl),
          sellerTradepoint: getTradePointInlineLabel(seller.tradePoint, intl),
        }}
      />
    );
  } else if (seller.tradePoint.id in metersMap) {
    description = (
      <FormattedMessage
        id="trade_rule.trade_rule_timeline.trade_rule_timeline_step_closed.sell.details"
        defaultMessage="{sellerTradepoint} no longer selling to {buyerTradepoint}"
        values={{
          buyerTradepoint: getTradePointInlineLabel(buyer.tradePoint, intl),
          sellerTradepoint: getTradePointInlineLabel(seller.tradePoint, intl),
        }}
      />
    );
  } else {
    description = (
      <FormattedMessage
        id="trade_rule.trade_rule_timeline.trade_rule_timeline_step_closed.trade_direction_unspecified.details"
        defaultMessage="{buyerTradepoint} no longer buying from {sellerTradepoint}"
        values={{
          buyerTradepoint: getTradePointInlineLabel(buyer.tradePoint, intl),
          sellerTradepoint: getTradePointInlineLabel(seller.tradePoint, intl),
        }}
      />
    );
  }

  return (
    <TradeRuleTimelineStep
      timezone={timezone}
      ruleId={ruleId}
      tradeType={tradeType}
      state={TRADE_RULE_STATE_CLOSED}
      timestamp={timestamp}
      user={user}
      icon={<FontAwesomeIcon icon={faStopCircle} />}
      isCurrentStep={isCurrentStep}
      hasNextStep={hasNextStep}
    >
      <li className="mb-3">
        {description}
      </li>
    </TradeRuleTimelineStep>
  );
}

TradeRuleTimelineStepClosed.propTypes = {
  metersMap: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  ruleId: PropTypes.string.isRequired,
  tradeType: PropTypes.string.isRequired,
  buyer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  seller: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  timestamp: PropTypes.number.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    givenName: PropTypes.string,
    familyName: PropTypes.string,
  }).isRequired,
  isCurrentStep: PropTypes.bool.isRequired,
  hasNextStep: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
};

TradeRuleTimelineStepClosed.defaultProps = {
};

export default TradeRuleTimelineStepClosed;
